<template>
    <div class="page">
      <SideMenu/>
      <Header/>
      <div class="jumps-prevent"></div>
      <div class="main-content side-content pt-0">
        <div class="container-fluid">
          <div class="inner-body">
            <router-view/>
          </div>
        </div>
      </div>
      <b-modal hide-footer v-model="incomingCallDialog"  size="sm">
        <div class="col">
          <p>
            Incoming Call From <strong>{{ callerDetails ? callerDetails.first_name + ' ' +  callerDetails.last_name: '' }}</strong>
          </p>
          <div class="btn-group" role="group">
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="declineCall"
            >
              Decline
            </button>
            <button
              type="button"
              class="btn btn-success ml-5"
              @click="acceptCall">
              Accept
            </button>
          </div>
        </div>
      </b-modal>
      <audio ref="callRingtone">
        <source src="../../assets/mp3/iphone-ringtone.mp3" type="audio/mpeg">
        Your browser does not support the audio element.
      </audio>
    </div>
</template>

<script>
import SideMenu from '../components/SideMenu'
import Header from '../components/Header'
import { mapActions } from 'vuex'
import EventBus from '../../event-bus'

export default {
  name: 'IndexLayout',
  components: {
    Header,
    SideMenu
  },
  data () {
    return {
      videoCallParams: {
        users: [],
        stream: null,
        receivingCall: false,
        caller: null,
        callerSignal: null,
        callAccepted: false,
        channel: null,
        peer1: null,
        peer2: null
      }
    }
  },
  computed: {
    incomingCallDialog () {
      if (this.videoCallParams.receivingCall) {
        return true
      }
      return false
    },
    callerDetails () {
      if (
        this.videoCallParams.caller
      ) {
        return this.videoCallParams.caller
      }
      return null
    }
  },
  created () {
    this.getLanguages().then(() => {}).catch(err => {
      if (err && err.response) {
        if (err.response.status === 422) {
          const data = err.response.data
          const keys = Object.keys(data)
          const msg = data[keys[0]]
          this.$toasted.error(msg).goAway(1500)
        } else {
          this.$toasted.error(err.response.message).goAway(1500)
        }
      }
    })
  },
  methods: {
    ...mapActions({
      getLanguages: 'language/getLanguages'
    }),
    declineCall () {
      this.videoCallParams.receivingCall = false
    },
    acceptCall () {
      EventBus.$emit('acceptCall')
      this.videoCallParams.receivingCall = false
    }
  }
}
</script>
<style>
</style>
